'use client';

import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { BrandingProvider } from '@terra/ui-design-system';
import type { UiBranding } from '@terra/ui-design-system';
import {
  DEFAULT_PRODUCT_BRAND_NAME,
  resolveProductBrandName,
} from '@terra/shared-utils';
import { getConfigValue } from '../../lib/public-env/get-config-value';

const DEFAULT_BRANDING: UiBranding = {
  brandName: DEFAULT_PRODUCT_BRAND_NAME,
  logoUrl: null,
  faviconUrl: null,
  isWhiteLabeled: false,
};

function toLogoUrl(value: string | undefined): string | null {
  const trimmed = value?.trim();

  if (!trimmed) {
    return null;
  }

  return trimmed;
}

export function BrandingInitProvider({ children }: { children: ReactNode }) {
  const branding = useMemo((): UiBranding => {
    const enabled =
      getConfigValue('NEXT_PUBLIC_UI_BRANDING_ENABLED') === 'true';

    if (!enabled) {
      return DEFAULT_BRANDING;
    }

    return {
      brandName: resolveProductBrandName({
        enabled: getConfigValue('NEXT_PUBLIC_UI_BRANDING_ENABLED'),
        name: getConfigValue('NEXT_PUBLIC_UI_BRANDING_NAME'),
      }),
      logoUrl: toLogoUrl(getConfigValue('NEXT_PUBLIC_UI_BRANDING_LOGO_BASE64')),
      faviconUrl: toLogoUrl(
        getConfigValue('NEXT_PUBLIC_UI_BRANDING_FAVICON_BASE64'),
      ),
      isWhiteLabeled: true,
    };
  }, []);

  return <BrandingProvider value={branding}>{children}</BrandingProvider>;
}
